import rlang from "../../../components/rlang-service";

const defaultCC = `
let Products = [{ 
    "Id": "product 1", 
    "Name": "title 1",
    "ImageUrl": "https://static.independent.co.uk/s3fs-public/thumbnails/image/2017/08/02/11/vegan-pizza-istock.jpg?w968h681"
}, { 
    "Id": "product 2", 
    "Name": "title 2",
    "ImageUrl": "https://static.independent.co.uk/s3fs-public/thumbnails/image/2017/08/02/11/vegan-pizza-istock.jpg?w968h681"
}, { 
    "Id": "product 3", 
    "Name": "title 3",
    "ImageUrl": "https://static.independent.co.uk/s3fs-public/thumbnails/image/2017/08/02/11/vegan-pizza-istock.jpg?w968h681"
}, {
    "Id": "product 4", 
    "Name": "title 4",
    "ImageUrl": "https://static.independent.co.uk/s3fs-public/thumbnails/image/2017/08/02/11/vegan-pizza-istock.jpg?w968h681"
}]
let CTA = "CTA 1"`;

const feedCC = `
let Products = [Feed.Select ("shopee_vn", "kc454047"), Feed.Select ("shopee_vn", "kc451890"), Feed.Select ("shopee_vn", "kc91847"), Feed.Select ("shopee_vn", "kc666226")]
let Products = Feed.SelectRandomN("shopee_vn", 5)
let CTA = "CTA 1"
        `;

const defaultFeedSampleId =
    {
        "1000114000": {
            "Id": "1000114000",
            "Name": "Jilbab lazmi motif",
            "Price": "40000",
            "ReducedPrice": "29200",
            "Sale": "27",
            "Brand": "Tidak Ada Merek",
            "ImageUrl": "723870745f98b983917b8809d75fcb41",
            "Shop": "17797514",
            "Key": "43",
            "RecommendedId": "1814448595"
        },
        "1000164304": {
            "Id": "1000164304",
            "Name": "TRAVEL TOOTHBRUSH CASE SOPHIE PARIS",
            "Price": "72900",
            "ReducedPrice": "20000",
            "Sale": "72",
            "Brand": "sophie paris",
            "ImageUrl": "63b00ca19d65c3457c65d09dd6488f2e",
            "Shop": "9968052",
            "Key": "40",
            "RecommendedId": "2019983759"
        },
        "100022501": {
            "Id": "100022501",
            "Name": "Ransel mox eye",
            "Price": "64000",
            "ReducedPrice": "36000",
            "Sale": "43",
            "Brand": "Tidak Ada Merek",
            "ImageUrl": "98b8a90d5541eb273684a1ce94097687",
            "Shop": "2797002",
            "Key": "36",
            "RecommendedId": "1234188927"
        },
        "1000230702": {
            "Id": "1000230702",
            "Name": "❤️SUPER MEGA SALE💛 • planet meaw fuwa fuwa Squishy Licensed",
            "Price": "150000",
            "ReducedPrice": "79500",
            "Sale": "47",
            "Brand": null,
            "ImageUrl": "097a2b728beeadb98dc34ec65c35bb1b",
            "Shop": "8809145",
            "Key": "42",
            "RecommendedId": "1486171072"
        },
        "1000254301": {
            "Id": "1000254301",
            "Name": "Flash Disk USB 3.0 Bahan Metal Kapasitas 64GB dengan Gantungan Kunci",
            "Price": "180000",
            "ReducedPrice": "81000",
            "Sale": "55",
            "Brand": null,
            "ImageUrl": "6bb25a056c3ead5910d28765fb6d29b8",
            "Shop": "54914962",
            "Key": "134",
            "RecommendedId": "1913302160"
        },
        "1000257401": {
            "Id": "1000257401",
            "Name": "Flash Disk OTG USB 2.0 Anti Air Bahan Metal untuk Android / Tablet / PC",
            "Price": "220000",
            "ReducedPrice": "72000",
            "Sale": "67",
            "Brand": null,
            "ImageUrl": "e92d099534a00c71f17d177bf44c77a6",
            "Shop": "54914962",
            "Key": "134",
            "RecommendedId": "1755463199"
        }
    }
;

const defaultFeedSampleVn =
    {
        "vnfeedid": {
            "Id": "vnfeedid",
            "Name": "Jilbab lazmi motif",
            "Price": "40000",
            "ReducedPrice": "29200",
            "Sale": "27",
            "Brand": "Tidak Ada Merek",
            "ImageUrl": "723870745f98b983917b8809d75fcb41",
            "Shop": "17797514",
            "Key": "43",
            "RecommendedId": "1814448595"
        }
    }
;

const defaultFeedSampleTh =
    {
        "thFeedid": {
            "Id": "thFeedid",
            "Name": "Jilbab lazmi motif",
            "Price": "40000",
            "ReducedPrice": "29200",
            "Sale": "27",
            "Brand": "Tidak Ada Merek",
            "ImageUrl": "723870745f98b983917b8809d75fcb41",
            "Shop": "17797514",
            "Key": "43",
            "RecommendedId": "1814448595"
        }
    }
;

const rl = rlang.NewInterpreter();

export {defaultCC, feedCC, rl, defaultFeedSampleVn, defaultFeedSampleId, defaultFeedSampleTh};
